import {Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'invitation-banner',
  providers: [],
  styleUrls: ['./invitation-banner.component.scss'],
  template: `
  <div class="invitation-banner">
    <div class="image-column"></div>
    <div class="info-column">
      <div class="info-content">
        <h1>{{title}}</h1>
        <h2>{{subtitle}}</h2>
        <ng-content></ng-content>
      </div>
    </div>
  </div>
  `
})

export class InvitationBannerComponent {
  @Input() title: string;

  @Input() subtitle: string;
}
